// extracted by mini-css-extract-plugin
module.exports = {"slider":"promotional-banner_slider__1_UDv","slider-container":"promotional-banner_slider-container__302uj","link":"promotional-banner_link__1zd3a"};